import Headline from "../../components/Headline/Headline";
import Hr from "../../components/Hr/Hr";
import Paragraph from "../../components/Paragraph/Paragraph";
import Text from "../../components/Text/Text";

const DataPrivacyPartial = () => {
  return (
    <Text>
      <Headline kind="l">Datenschutzhinweise für die Nutzung des BikeCenters</Headline>

      <Hr />

      <Headline kind="m">Verantwortlichkeit für die Datenverarbeitung</Headline>
      <Paragraph>
        Das BikeCenter ist ein Beratungs- und Verkaufstool für Fahrradfachhändler. Verantwortlich für die Verarbeitung
        personenbezogener Daten, welche durch Ihre Nutzung des BikeCenters anfallen, ist der jeweilige
        Fahrradfachhändler, welcher das BikeCenter einsetzt (Im Folgenden: &ldquo;Wir&rdquo;).
      </Paragraph>

      <Paragraph>
        Folglich sind wir als Betreiber des BikeCenters Verantwortlicher gem. Art. 4 Nr. 7 der
        EU-Datenschutz-Grundverordnung (DSGVO). Bei Fragen können Sie sich gerne jederzeit an unsere Mitarbeiter wenden
        oder auf die Kontaktwege unserer Webseite zurückgreifen.
      </Paragraph>

      <Headline kind="m">Modalitäten der Datenverarbeitung</Headline>
      <Headline>Kategorien und Quellen personenbezogener Daten</Headline>
      <Paragraph>
        Wir verarbeiten Ihre personenbezogenen Daten insoweit diese bei der Nutzung des BikeCenters anfallen
        (Nutzungsdaten). Diese Daten erheben wir somit direkt bei Ihnen. Eine persönliche Identifikation ist in diesem
        Rahmen nur möglich, sofern Sie Daten angeben, welche solche Rückschlüsse auf Ihre Person erlauben.
      </Paragraph>

      <Paragraph>
        Personenbezogene Nutzungsdaten können dabei z.B. sein: Name, Anrede, Kontaktdaten (Postadresse, Telefon,
        E-Mail-Adresse), Geburtsdatum usw.
      </Paragraph>

      <Paragraph>
        Informationen über das Verhalten bei der Nutzung unseres Tools und unserer Dienste, wie beispielsweise Beginn
        und Ende der Nutzung des Tools und welche Inhalte Sie abgerufen, erheben wir lediglich anonymisiert.
        Rückschlüsse auf Ihre Person sind in diesem Zusammenhang nicht möglich.
      </Paragraph>

      <Headline>Zweck und Rechtsgrundlage der Datenverarbeitung</Headline>
      <Paragraph>
        Wir möchten Ihnen im Folgenden so transparent wie möglich darstellen, welche Daten wir von Ihnen zu welcher
        Gelegenheit, auf welcher Grundlage und zu welchem Zweck verarbeiten.
      </Paragraph>

      <Headline kind="s">Teilen von Dokumenten via E-Mail</Headline>
      <Paragraph>
        Das BikeCenter bietet Ihnen die Möglichkeit, Dokumente an Ihre persönliche E-Mail-Adresse zu senden.
      </Paragraph>
      <Paragraph>
        Bevor das Dokument an Ihre E-Mail-Adresse versandt wird, muss dies durch einen Mitarbeiter freigegeben werden.
        Da wir Sie vor Versand des Dokuments um Ihre Einwilligung bitten, ist Rechtsgrundlage für die Datenverarbeitung
        zum Versand des Dokuments Art. 6 Abs. 1 S. 1 Buchstabe a) DSGVO (Einwilligung der betroffenen Person). Diese
        Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.
      </Paragraph>
      <Paragraph>Wir verwenden für den E-Mail-Versand folgenden externen Dienstleister:</Paragraph>

      <Headline kind="s">Sendgrid</Headline>
      <Paragraph>
        Wir nutzen für die Funktion &ldquo;Dokument teilen&rdquo; den Dienst Sendgrid von Twillio SendGrid, 1801
        California Street, Suite 500, Denver, CO 80202 USA.
      </Paragraph>
      <Paragraph>
        Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von Sendgrid:{" "}
        https://www.twilio.com/legal/privacy
      </Paragraph>

      <Headline kind="s">Zugriff auf die Dienste von Drittanbietern</Headline>
      <Paragraph>
        Das BikeCenter kann unter anderem dazu genutzt werden, die Dienste von Drittarbeitern abzurufen. Hierzu werden
        Sie in erkennbarer Weise auf die Webseiten dieser Anbieter weitergeleitet. Sofern Sie dort personenbezogene
        Daten angeben, findet die Verarbeitung dieser Daten durch die Drittanbieter in deren datenschutzrechtlichen
        Verantwortung statt. Weitere Informationen hierzu finden Sie auf den Datenschutzhinweisen der aufgerufenen
        Webseiten dieser Anbieter.
      </Paragraph>
      <Paragraph>
        In manchen Fällen findet vor dem Zugang zur jeweiligen Anwendung eine Verknüpfung und Übermittlung der Händler-
        oder Kundennummer respektive den Anmeldedaten an den Drittanbieter statt. In diesen Fällen ist unsere
        Rechtsgrundlage Art. 6 Abs. 1 lit. f.) DSGVO. Unser berechtigtes Interesse besteht in der Ermöglichung des
        jeweiligen Dienstes, sowie ggf. der Ermöglichung der Zuordnung von Provisionszahlungen.
      </Paragraph>

      <Headline kind="s">Videoberatung</Headline>
      <Paragraph>
        Auf Ihren Wunsch können Sie von Ihrem Endgerät aus an einer Videoberatung teilnehmen, welche es Ihnen erlaubt
        über die Kamera des BikeCenters direkt mit unseren Mitarbeitern kommunizieren.
      </Paragraph>
      <Paragraph>
        Hierbei findet die Kommunikation über Whereby statt. Insoweit die Kommunikation sich im Rahmen bloßer
        Telekommunikationsdienstleistungen hält, ist Whereby aufgrund in diesem Rahmen einzuhaltender gesetzlicher
        Pflichten selbst Verantwortlicher für die Datenübermittlung.
      </Paragraph>
      <Paragraph>
        Sofern im Einzelfall eine darüberhinausgehende Datenverarbeitung anfällt, ist unsere Rechtsgrundlage Art. 6 Abs.
        1 lit. f) DSGVO. Unser berechtigtes Interesse besteht in der effektiven Beratung und Kommunikation mit unseren
        Kunden.
      </Paragraph>

      <Paragraph>Bei Whereby handelt es sich um:</Paragraph>
      <Paragraph>
        Whereby AS
        <br />
        Gate 1 no. 107, 6700 Måløy, Norway
      </Paragraph>

      <Headline>Speicherdauer</Headline>
      <Paragraph>
        Wir verarbeiten Ihre personenbezogenen Daten nur so lange, wie dies für die Erreichung des jeweiligen Zwecks
        erforderlich ist, es sei denn es stehen gesetzliche Aufbewahrungspflichten der Löschung entgegen, z.B. aus dem
        Handelsrecht oder dem Steuerrecht.
      </Paragraph>

      <Headline>Datenübermittlung an Drittstaaten außerhalb der EU</Headline>
      <Paragraph>
        Alle Informationen, die wir von Ihnen erhalten, werden grundsätzlich auf Servern innerhalb der Europäischen
        Union verarbeitet. Eine Übermittlung Ihrer Daten an oder eine Verarbeitung Ihrer Daten in Drittstaaten erfolgt
        ohne Ihre ausdrückliche Einwilligung lediglich, sofern dies gesetzlich vorgesehen oder gestattet ist, in dem
        Drittstaat ein hierfür angemessenes Datenschutzniveau sichergestellt ist oder vertragliche Verpflichtungen durch
        sogenannte Standarddatenschutzklauseln der EU bestehen.
      </Paragraph>

      <Headline>Weitergabe von Daten, Auftragsverarbeitung</Headline>
      <Paragraph>
        Wir geben Ihre personenbezogenen Daten niemals unberechtigt an Dritte weiter. Wir können Ihre Daten aber
        insbesondere an Dritte weitergeben, wenn Sie in die Datenweitergabe eingewilligt haben, wenn die Weitergabe zur
        Erfüllung unserer rechtlichen Verpflichtungen notwendig ist oder wenn wir aufgrund gesetzlicher Bestimmungen
        oder behördlicher oder gerichtlicher Anordnungen zu einer Datenweitergabe berechtigt oder verpflichtet sind.
        Dabei kann es sich insbesondere um die Auskunftserteilung für Zwecke der Strafverfolgung, zur Gefahrenabwehr
        oder zur Durchsetzung geistiger Eigentumsrechte handeln.
      </Paragraph>
      <Paragraph>
        Unter Umständen übermitteln wir Ihre Daten außerdem an externe Dienstleister, die Daten in unserem Auftrag und
        nach unserer Weisung verarbeiten (Auftragsverarbeiter), um unsere eigene Datenverarbeitung zu vereinfachen oder
        zu entlasten. Jeder Auftragsverarbeiter wird durch einen Vertrag nach Maßgabe des Art. 28 DSGVO verpflichtet.
        Das heißt insbesondere, dass der Auftragsverarbeiter hinreichend Garantien dafür zu bieten hat, dass durch ihn
        geeignete technische und organisatorische Maßnahmen so durchgeführt werden, dass die Verarbeitung im Einklang
        mit den Anforderungen der DSGVO erfolgt und der Schutz Ihrer Rechte als betroffene Person gewährleistet ist.
        Trotz Beauftragung von Auftragsverarbeitern bleiben wir für die Verarbeitung Ihrer personenbezogenen Daten die
        verantwortliche Stelle im Sinne der Datenschutzgesetze.
      </Paragraph>

      <Paragraph>
        Zentraler Auftragsverarbeiter in Bezug auf das BikeCenter ist die DealerCenter Digital GmbH, von welcher wir das
        BikeCenter mitsamt Hard- und Softwarekomponenten beziehen.
      </Paragraph>

      <Headline>Automatisierte Entscheidungsfindung/ Profiling</Headline>
      <Paragraph>
        Eine ausschließliche automatisierte Verarbeitung Ihrer personenbezogenen Daten, die darin besteht Ihre
        persönlichen Aspekte zu analysieren und zu bewerten (Profiling), findet nicht statt.
      </Paragraph>

      <Headline>Datenschutzmaßnahmen</Headline>
      <Paragraph>
        Wir sichern unser Tool– und damit auch Ihre Daten – durch technische und organisatorische Maßnahmen gegen
        Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung durch unbefugte Personen ab. Insbesondere werden Ihre
        persönlichen Daten verschlüsselt durch das Internet übertragen. Wir bedienen uns dabei des Codierungssystems TLS
        (Transport Layer Security).
      </Paragraph>
      <Paragraph>
        Jedoch ist die Übertragung von Informationen über das Internet nie vollständig sicher, weshalb wir die
        Sicherheit der von unserem Tool übermittelten Daten nicht zu 100% garantieren können.
      </Paragraph>

      <Headline kind="m">Betroffenenrechte</Headline>
      <Headline>Ihre Rechte als betroffene Person</Headline>
      <Paragraph>
        Als betroffene Person haben Sie gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:
      </Paragraph>

      <ul>
        <li>
          Ein <strong>Recht auf Auskunft</strong> unter anderem über die Kategorien der verarbeiteten Daten, der
          Verarbeitungszwecke, die Speicherdauer sowie etwaige Empfänger, gemäß Art. 15 DSGVO.
        </li>

        <li>
          Ein <strong>Recht auf Berichtigung oder Löschung</strong> unrichtiger bzw. unvollständiger Daten, gemäß Art.
          16 und 17 DSGVO.
        </li>

        <li>
          Unter den Voraussetzungen des Art. 18 DSGVO ein <strong>Recht auf Einschränkung der Verarbeitung</strong>.
        </li>

        <li>
          Ein <strong>Recht auf Widerspruch</strong> gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO, soweit die
          Datenverarbeitung aufgrund eines berechtigten Interesses erfolgte.
        </li>

        <li>
          Ein <strong>Recht auf Widerruf</strong> einer abgegebenen Einwilligung mit Wirkung für die Zukunft gemäß Art.
          7 Abs. 3 DSGVO.
        </li>

        <li>
          Ein <strong>Recht auf Datenübertragbarkeit</strong> in einem gängigen Format gemäß Art. 20 DSGVO.
        </li>

        <li>
          Sie haben zudem das Recht, sich gemäß Art. 77 DSGVO bei einer <strong>Datenschutz-Aufsichtsbehörde</strong>{" "}
          über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren, insbesondere in dem Mitgliedstaat
          Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
        </li>

        <li>
          Wenn Sie diese Rechte uns gegenüber geltend machen, werden wir die dabei an uns übermittelten Daten
          verarbeiten, um Ihnen Ihre Rechte zu gewähren. Im Anschluss speichern wir die von Ihnen an uns übermittelten
          Daten und die von uns an Sie im Gegenzug übermittelten Daten zum Zwecke der Dokumentation bis zum Ablauf der
          ordnungswidrigkeitsrechtlichen Verjährungsfrist (3 Jahre). Die Rechtsgrundlage für die Speicherung der Daten
          ist Art. 6 Abs. 1 S. 1 lit. f) DSGVO (berechtigtes Interesse an der Datenverarbeitung). Das berechtigte
          Interesse ergibt sich aus dem Bedarf, uns in einem möglichen Bußgeldverfahren entlasten zu können, indem wir
          nachweisen, dass wir Ihrem Anliegen ordnungsgemäß nachgekommen sind.
        </li>
      </ul>

      <Paragraph>
        Der Verarbeitung Ihrer Daten auf Grundlage unseres berechtigten Interesses können Sie jederzeit unter den
        Voraussetzungen des Art. 21 DSGVO widersprechen. Wir weisen aber darauf hin, dass die Verarbeitung Ihrer Daten
        zum Nachweis der Einhaltung der Betroffenenrechte zwingend im Sinne des Art. 21 Abs. 1 DSGVO ist, da andere
        Nachweismöglichkeiten nicht bestehen bzw. nicht gleichermaßen geeignet sind.
      </Paragraph>
    </Text>
  );
};

export default DataPrivacyPartial;
